"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Webcam = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "webcam" },
            react_1.default.createElement("path", { id: "Icon", d: "M8 21C7.44772 21 7 21.4477 7 22C7 22.5523 7.44772 23 8 23V21ZM16 23C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21V23ZM19.5 10.5C19.5 14.6421 16.1421 18 12 18V20C17.2467 20 21.5 15.7467 21.5 10.5H19.5ZM12 18C7.85786 18 4.5 14.6421 4.5 10.5H2.5C2.5 15.7467 6.75329 20 12 20V18ZM4.5 10.5C4.5 6.35786 7.85786 3 12 3V1C6.75329 1 2.5 5.25329 2.5 10.5H4.5ZM12 3C16.1421 3 19.5 6.35786 19.5 10.5H21.5C21.5 5.25329 17.2467 1 12 1V3ZM14.1875 10.5C14.1875 11.7081 13.2081 12.6875 12 12.6875V14.6875C14.3127 14.6875 16.1875 12.8127 16.1875 10.5H14.1875ZM12 12.6875C10.7919 12.6875 9.8125 11.7081 9.8125 10.5H7.8125C7.8125 12.8127 9.68731 14.6875 12 14.6875V12.6875ZM9.8125 10.5C9.8125 9.29188 10.7919 8.3125 12 8.3125V6.3125C9.68731 6.3125 7.8125 8.18731 7.8125 10.5H9.8125ZM12 8.3125C13.2081 8.3125 14.1875 9.29188 14.1875 10.5H16.1875C16.1875 8.18731 14.3127 6.3125 12 6.3125V8.3125ZM8 23H16V21H8V23Z" }))));
};
exports.default = Webcam;
